export const SCROLL_THRESHOLD = 1000;

export const GRID_CHUNK_SIZE = 50;

export const SKELETON_CARD_COUNT = 5;
